import type { SoftwareQualityAssuranceCourse } from "../type";

const courseImage1 = new URL("../_image/WhatsApp Image 2026-04-21 at 2.46.32 PM.jpeg", import.meta.url).href;
const courseImage2 = new URL("../_image/WhatsApp Image 2026-04-21 at 2.46.33 PM.jpeg", import.meta.url).href;
const courseImage3 = new URL("../_image/WhatsApp Image 2026-04-21 at 2.46.33 PM (1).jpeg", import.meta.url).href;
const courseImage4 = new URL("../_image/WhatsApp Image 2026-04-21 at 2.46.33 PM (2).jpeg", import.meta.url).href;
const courseImage5 = new URL("../_image/WhatsApp Image 2026-04-21 at 2.46.34 PM.jpeg", import.meta.url).href;
const courseImage6 = new URL("../_image/WhatsApp Image 2026-04-21 at 2.46.34 PM (1).jpeg", import.meta.url).href;
const courseImage7 = new URL("../_image/WhatsApp Image 2026-04-21 at 2.46.34 PM (2).jpeg", import.meta.url).href;

export const softwareQualityAssuranceCoursePath = "/courseDetails/software-quality-assurance";

export const softwareQualityAssuranceCourse: SoftwareQualityAssuranceCourse = {
  id: "software-quality-assurance-training",
  title: "軟件測試編寫員課程",
  topic: "Software Quality Assurance Training",
  content:
    "由 ARES Charitable Foundation 贊助，基督教勵行會數碼學習中心與天程學院攜手合作開辦，免費為 17-35 歲年青人提供資訊科技職業技能訓練，配以就業支援服務，幫助年青人開展理想事業。",
  status: "已結束",
  partner: "基督教勵行會數碼學習中心 × Teen Future Academy",
  sourceUrl: "https://www.cats.org.hk/digital-learning-centre/sw-testing",
  facts: [
    {
      key: "classTime",
      label: "上課時間",
      value: "逢星期二、四 18:30-21:30；星期六 09:00-18:00",
    },
    {
      key: "hours",
      label: "修讀時長",
      value: "約 3 個月",
    },
    {
      key: "location",
      label: "教室地址",
      value: "長沙灣大南西街 1016-1018 號東方國際大廈 15 樓 1507 室 Teen Future 天程學院",
    },
    {
      key: "price",
      label: "課程費用",
      value: "課程費用全免，成功入學須繳付 HK$4,000 保證金",
    },
    {
      key: "contentNote",
      label: "課程內容",
      value: "Manual Testing、Java、自動化測試工具、AI 工具、IT 職能與項目管理",
    },
    {
      key: "language",
      label: "教學形式",
      value: "實體面授課",
    },
  ],
  media: {
    kind: "image",
    src: courseImage1,
    alt: "軟件測試編寫員課程畢業合照",
  },
  carouselImages: [
    {
      src: courseImage1,
      alt: "軟件測試編寫員課程畢業合照",
    },
    {
      src: courseImage2,
      alt: "軟件測試編寫員課程課堂相片一",
    },
    {
      src: courseImage3,
      alt: "軟件測試編寫員課程課堂相片二",
    },
    {
      src: courseImage4,
      alt: "軟件測試編寫員課程課堂相片三",
    },
    {
      src: courseImage5,
      alt: "軟件測試編寫員課程課堂相片四",
    },
    {
      src: courseImage6,
      alt: "軟件測試編寫員課程課堂相片五",
    },
    {
      src: courseImage7,
      alt: "軟件測試編寫員課程課堂相片六",
    },
  ],
  highlights: [
    "掌握 Manual Testing 基礎與測試用例設計方法，建立系統化測試思維",
    "學習 Java 入門基礎，運用 Playwright、Selenium、Appium 等自動化測試工具",
    "活用 AI 工具 Qwen-Code、Browser-Use，提升程式編寫與網頁操作效率",
    "認識 IT 職能架構與項目管理流程，強化職場通用技能",
    "導師指導完成完整 QA 專案流程，涵蓋設計、執行與交付階段",
  ],
  requirements: [
    "17-35 歲青年人，失業、待業或就業不足優先考慮",
    "中五或以上",
    "良好中英文能力",
    "懂基礎電腦視窗操作",
    "完成課程後，立即投身相關行業",
    "須通過面試評核甄選",
  ],
  employmentSupport: ["協助學員完成實戰項目，求職時可以展示實力", "就業主任 Placement Officer 給予指導意見及跟進"],
  schedule: [
    "日期：2026 年 01 月 10 日開始，為期約 3 個月",
    "時間：逢星期二、四 18:30-21:30；星期六 09:00-18:00",
    "形式：實體面授課",
    "地點：長沙灣大南西街 1016-1018 號東方國際大廈 15 樓 1507 室 Teen Future 天程學院",
  ],
  fees: [
    "由 ARES Charitable Foundation 贊助，課程費用全免，成功入學須繳付 HK$4,000 保證金",
    "出席率達 8 成或以上及完成課程畢業要求，並於 6 個月就業跟進期內成功投身 I.T. 行業，跟進期完結後將獲退回保證金",
  ],
};
